import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  modal: { boxSizing: 'border-box', top: '-5.5rem', maxHeight: '75rem' },
  title: {
    marginTop: '4rem',
    marginBottom: '0.4rem',
    font: { size: '2.8rem', lineHeight: '4rem', weight: 700 },
    textAlign: 'center',
    letterSpacing: '0.02rem',
  },
  subTitle: {
    textAlign: 'center',
    margin: { bottom: '2.4rem' },
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 400 },
    letterSpacing: '0.02rem',
    color: colors.neutral[700],
  },
  form: {
    borderRadius: '6px',
    border: `1px solid ${colors.neutral[300]}`,
    padding: '3.2rem 5.6rem',
    maxWidth: '52.8rem',
    margin: '0 auto',
    boxSizing: 'border-box',
  },
  agentActionButton: { fontWeight: 700 },
  agentsGroupWrapper: { marginBottom: '4.8rem', '&:last-of-type': { marginBottom: 0 } },
  sectionTitle: {
    margin: 0,
    padding: { bottom: '0.8rem' },
    font: { size: '1.8rem', lineHeight: '2.4rem', weight: 700 },
    letterSpacing: '0.03rem',
    color: colors.neutral[900],
  },
  modalSelect: { marginBottom: '4.8rem', width: '100%' },
  agentsList: {
    borderTop: `1px solid ${colors.neutral[700]}`,
    margin: 0,
    padding: { top: '1.2rem' },
    listStyle: 'none',
  },
  agentRecord: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '0.8rem',
    '&:last-of-type': { marginBottom: 0 },
  },
  agent: {
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 400 },
    letterSpacing: '0.02rem',
    color: colors.neutral[900],
    display: 'inline',
    verticalAlign: 'middle',
  },
  agentName: {
    marginRight: '0.8rem',
  },
  modalFooter: {
    paddingTop: '4rem',
    display: 'flex',
    justifyContent: 'center',
    margin: '0 auto',
    width: '34.4rem',
    paddingBottom: '3rem',
    '& button:not(:first-child)': {
      marginLeft: '2.6rem',
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
